import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ProjetcsService } from '../../../projects/projetcs.service';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';

@Component({
    selector: 'app-add-catering',
    templateUrl: './add-catering.component.html',
    styleUrls: ['./add-catering.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddCateringComponent implements OnInit {
	@Input() types: any;
	@Input() projectId?: any;
	@Input() catering: any;
	@Input() shooting: any;
	@Input() hasShooting: boolean = true;
	@Input() lists: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();
	loading: boolean = false;
	formData: any = {
		'catering_type_id': '',
		'quantity': '',
		'location': '',
		'time': '',
		'date': null,
		'shooting_id': null,
		'unit_id': ''
	}

	error: string;

	submitForm() {
		this.loading = true;
		let cateringId = this.catering ? this.catering.id : null;
		// shooting 
		if (this.hasShooting) {
			this.formData.shooting_id = this.shooting ? this.shooting.id : this.catering.shooting_schedule_id;
		} else {
			// catering without shooting
			this.formData.project_id = this.projectId;
		}
		this._pS.createCateringCall(cateringId, this.formData)
			.subscribe(
				(data: any) => {
					this.loading = false;
					if (data.error) {
						this.error = data.msg;
						return;
					}
					this.notify.emit();
				}
			)
	}

	close() {
		event.stopPropagation();
		this.closeView.emit()
	}

	fillForm() {
		this.formData.catering_type_id = this.catering.catering_type_id;
		this.formData.quantity = this.catering.quantity;
		this.formData.location = this.catering.location;
		this.formData.cost_unit = this.catering.cost_unit;

		this.formData.time = this.shooting ? this.catering.time : this._gS.getStaticStringHour(this.catering.time);
		this.formData.date = this.catering.date ? this.catering.date : null;
	}

	showFields() {
		if (this.shooting) {
			return this.shooting.shooting_shedule_status_id == 2 || this.shooting.shooting_shedule_status_id == 3;
		}
		return true;
	}

	constructor(private _pS: ProjetcsService, public _gS: GlobalService, private _fS: FilterService, private datePipe: DatePipe) { }

	ngOnInit() {
		if (this.catering) {
			this.fillForm();
		}
	}

}
